module.exports = "/lucky-balls/img/drawnballs/red.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drawnballs/red.png
// module id = 1014
// module chunks = 0